exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".greyCC {\n  color: #cccccc; }\n\n.grey40 {\n  color: #404040; }\n\n.grey9b {\n  color: #9b9b9b; }\n\n.grey99 {\n  color: #999999; }\n\n.grey88 {\n  color: #888888; }\n\n.green {\n  color: #63B508; }\n\n.orange {\n  color: #FE5815; }\n\n.white-opac {\n  color: rgba(255, 251, 251, 0.6); }\n\n.white-opac3 {\n  color: rgba(255, 251, 251, 0.3); }\n\n.white-opac2 {\n  color: rgba(255, 251, 251, 0.7); }\n\n.black-opac {\n  color: rgba(0, 0, 0, 0.6); }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /var/www/angular/mobilit-web/node_modules/css-loader?{"sourceMap":false,"importLoaders":1}!/var/www/angular/mobilit-web/node_modules/postcss-loader?{"ident":"postcss"}!/var/www/angular/mobilit-web/node_modules/sass-loader/lib/loader.js?{"sourceMap":false,"precision":8,"includePaths":[]}!/var/www/angular/mobilit-web/src/styles/variables.scss
// module id = ../../../../css-loader/index.js?{"sourceMap":false,"importLoaders":1}!../../../../postcss-loader/index.js?{"ident":"postcss"}!../../../../sass-loader/lib/loader.js?{"sourceMap":false,"precision":8,"includePaths":[]}!../../../../../src/styles/variables.scss
// module chunks = styles